import { CSSProperties, ReactNode } from 'react'
import { z } from 'zod'
import { ConformedBranding } from '../branding'

// any string that isn't one of these is expected to be a CSS-ready color
export const brandForegroundColorConstant = 'var(--brand-foreground)'
export const brandBackgroundColorConstant = 'var(--brand-background)'
export const brandAccentForegroundColorConstant = 'var(--brand-accent-foreground)'
export const brandAccentBackgroundColorConstant = 'var(--brand-accent-background)'
export const transparentColorConstant = 'transparent'

export const commonColorOptions = [
	'rgba(0,0,0,1)',
	'rgba(255,255,255,1)',
	brandForegroundColorConstant,
	brandBackgroundColorConstant,
	brandAccentForegroundColorConstant,
	brandAccentBackgroundColorConstant,
]

// Yes, this is redundant. Leaving this here to be self-descriptive.
export const colorSchema = z.union([
	z.literal(brandForegroundColorConstant),
	z.literal(brandBackgroundColorConstant),
	z.literal(brandAccentForegroundColorConstant),
	z.literal(brandAccentBackgroundColorConstant),
	z.literal(transparentColorConstant),
	z.string(),
])

export const specialColors = {
	brandForeground: brandForegroundColorConstant,
	brandBackground: brandBackgroundColorConstant,
	brandAccentForeground: brandAccentForegroundColorConstant,
	brandAccentBackground: brandAccentBackgroundColorConstant,
	transparent: transparentColorConstant,
}

export const specialColorLabels = {
	brandForeground: 'Foreground',
	brandBackground: 'Background',
	brandAccentForeground: 'Accent FG',
	brandAccentBackground: 'Accent BG',
	transparent: 'Transparent',
}

export const specialColorLookup = {
	[brandForegroundColorConstant]: 'Foreground',
	[brandBackgroundColorConstant]: 'Background',
	[brandAccentForegroundColorConstant]: 'Accent FG',
	[brandAccentBackgroundColorConstant]: 'Accent BG',
	[transparentColorConstant]: 'Transparent',
}

export type Color = z.infer<typeof colorSchema>

export function ColorProvider(
	{ children, brandingPalette }: {
		children: ReactNode
		brandingPalette: Pick<ConformedBranding, 'foreground' | 'background' | 'accentForeground' | 'accentBackground'>
	},
) {
	return (
		<div
			data-is="color-provider"
			style={{
				'--brand-foreground': brandingPalette.foreground,
				'--brand-background': brandingPalette.background,
				'--brand-accent-foreground': brandingPalette.accentForeground,
				'--brand-accent-background': brandingPalette.accentBackground,
			} as CSSProperties}
		>
			{children}
		</div>
	)
}
